import React from 'react';
import { Link } from 'react-router-dom';
import './Solutions.css';

function Solutions() {
    return (
        <div className="solutions">
            <div className="col-md-6 mx-auto">
                <div className="solution_text mx-auto">
                    <h1>
                        <span>HR</span> Solutions Value
                    </h1>
                </div>
            </div>
            <div className="solution_box">
                <div className="col-md-9 row mx-auto">
                    <div className="col-md-3 mb-5">
                        <Link className="values-link" to="/values">
                            <div className="box">
                                <img src="/images/dhart/Payrollbg.png" alt="image" />
                                <h2>Payroll Management</h2>
                            </div>
                        </Link>
                    </div>
                    <div className="col-md-3 mb-5">
                        <Link className="values-link" to="/values">
                            <div className="box1">
                                <img src="/images/dhart/Databg.png" alt="image" />
                                <h2>Employee Database</h2>
                            </div>
                        </Link>
                    </div>
                    <div className="col-md-3 mb-5">
                        <Link className="values-link" to="/values">
                            <div className="box2">
                                <img src="/images/dhart/trainingbg.png" alt="image" />
                                <h2>Training and Development</h2>
                            </div>
                        </Link>
                    </div>
                    <div className="col-md-3 mb-5">
                        <Link className="values-link" to="/values">
                            <div className="box3">
                                <div className="back_box">
                                    <img src="/images/dhart/RightArrowbg.png" alt="image" />
                                </div>
                                <h2>See All</h2>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Solutions;
